"use strict";
exports.__esModule = true;
exports.parseStakeAccountInfo = exports.tryParseAsVoteAccount = exports.parseVoteAccountInfo = exports.tryParseAsTokenAccount = exports.parseTokenAccountInfo = void 0;
var superstruct_1 = require("superstruct");
var constants_1 = require("../program/constants");
var validators_1 = require("../validators");
var stake_1 = require("./stake");
var token_1 = require("./token");
var vote_1 = require("./vote");
function parseTokenAccountInfo(info) {
    return (0, superstruct_1.create)(info, token_1.TokenAccountInfo);
}
exports.parseTokenAccountInfo = parseTokenAccountInfo;
function tryParseAsTokenAccount(data) {
    var routine = function () {
        var info = (0, superstruct_1.create)(data.parsed, validators_1.ParsedInfo);
        if (data.program === "spl-token") {
            var parsed = (0, superstruct_1.create)(info, token_1.TokenAccount);
            if (parsed.type === "account") {
                return parseTokenAccountInfo(parsed.info);
            }
        }
        return undefined;
    };
    return onThrowReturnError(routine);
}
exports.tryParseAsTokenAccount = tryParseAsTokenAccount;
function parseVoteAccountInfo(info) {
    return (0, superstruct_1.create)(info, vote_1.VoteAccountInfo);
}
exports.parseVoteAccountInfo = parseVoteAccountInfo;
function tryParseAsVoteAccount(data) {
    var routine = function () {
        var info = (0, superstruct_1.create)(data.parsed, validators_1.ParsedInfo);
        if (data.program === constants_1.PARSED_PROGRAMS.VOTE) {
            var parsed = (0, superstruct_1.create)(info, vote_1.VoteAccount);
            return parseVoteAccountInfo(parsed.info);
        }
        return undefined;
    };
    return onThrowReturnError(routine);
}
exports.tryParseAsVoteAccount = tryParseAsVoteAccount;
function parseStakeAccountInfo(info) {
    return (0, superstruct_1.create)(info, stake_1.StakeAccountInfo);
}
exports.parseStakeAccountInfo = parseStakeAccountInfo;
function onThrowReturnError(fn) {
    try {
        return fn();
    }
    catch (e) {
        return e instanceof Error ? e : new Error(JSON.stringify(e));
    }
}
//# sourceMappingURL=parser.js.map